import { makeVar } from '@apollo/client';
import { PopoverProps } from '@mui/material/Popover';

export const selectedJob = makeVar<PopoverProps['anchorEl']>(null);
export const selectedJobId = makeVar<string | null>(null);
